module.exports = __webpack_public_path__ + "static/media/comfort-keepers.acdfbf17.png";